var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upsell-page" }, [
    _c("div", { staticClass: "upsell-page__header" }, [
      _c(
        "div",
        {
          staticClass: "upsell-page__header-logo",
          on: {
            click: function($event) {
              return _vm.goToUrl("/home")
            }
          }
        },
        [_c("CompassLogo", { attrs: { type: "logo", width: 160 } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "upsell-page__content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "upsell-page__content-title typographies-display-large"
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Passez à la vitesse supérieure !")) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "upsell-page__content-informations typographies-paragraph-x-large-regular"
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Pour utiliser la fonctionnalité à laquelle vous souhaitez accéder, vous devez passer au plan supérieur."
                )
              ) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upsell-page__content-buttons" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.contact_sales"),
              size: "large"
            },
            on: { click: _vm.contactASale }
          }),
          _vm._v(" "),
          _c("CompassLink", {
            attrs: {
              label: _vm.$t.__("pages.UpsellPage.back_dashboard"),
              link: "/home",
              size: "large"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upsell-page__content-illustration" }, [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/services-upgrade.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }